import React from "react";
import { useTranslation } from "react-i18next";
import { Card } from "@shadcn-in-nx/ui/card";
import { Check, Pencil, X } from "lucide-react";

export default function AIPerformanceStats({ totals }) {
    const { t } = useTranslation();
    if (!totals || totals.total === 0) return null;

    const acceptRate = Math.round((totals.accepted / totals.total) * 100);
    const editRate = Math.round((totals.edited / totals.total) * 100);
    const denyRate = Math.round((totals.denied / totals.total) * 100);

    const stats = [
        { label: t("admin.support.accepted", "Accepted"), value: totals.accepted, rate: acceptRate, color: "text-green-600", bg: "bg-green-50", icon: Check },
        { label: t("admin.support.edited", "Edited"), value: totals.edited, rate: editRate, color: "text-yellow-600", bg: "bg-yellow-50", icon: Pencil },
        { label: t("admin.support.denied", "Denied"), value: totals.denied, rate: denyRate, color: "text-red-600", bg: "bg-red-50", icon: X },
    ];

    return (
        <div className="grid grid-cols-3 gap-4">
            {stats.map((s) => (
                <Card key={s.label} className={`p-4 ${s.bg}`}>
                    <div className="flex items-center gap-2 mb-1">
                        <s.icon className={`w-4 h-4 ${s.color}`} />
                        <span className="text-sm font-medium">{s.label}</span>
                    </div>
                    <div className="flex items-baseline gap-2">
                        <span className={`text-2xl font-bold ${s.color}`}>{s.rate}%</span>
                        <span className="text-xs text-muted-foreground">({s.value}/{totals.total})</span>
                    </div>
                </Card>
            ))}
        </div>
    );
}
